// { version: string; fixes:{ timestamp: number, level: updateLevel }[] }

// export type updateLevel = 'LOW' | 'MEDIUM' | 'HIGH';
export enum UpdateLevel {
  Low = 'LOW',
  Medium = 'MEDIUM',
  High = 'HIGH',
}

type TFixItem = { timestamp: number; level: UpdateLevel };

export const defaultTitle = 'Dashboard';

export const castUpdatesHistory = (response: any) => {
  return {
    version: String(response.version),
    updates: (response.updates || []).reduce((prev: TFixItem[], curr: any) => {
      const timestamp = Number(curr.timestamp);
      const level = String(curr.level) as UpdateLevel;

      return timestamp > 0 && Object.values(UpdateLevel).includes(level)
        ? [
            ...prev,
            {
              timestamp,
              level,
            },
          ]
        : prev;
    }, []) as TFixItem[],
  };
};

export type TUpdateResponse = ReturnType<typeof castUpdatesHistory>;
